import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import BlockA from '../../_block_components/block_a';
import BlockB from '../../_block_components/block_b';
import ContactsBlock from '../../other_components/callback_btn/contacts_block';
import MapBlock from '../../_block_components/map_block';
import ContactsAdressBlock from '../../_block_components/contacts_adress_block';
import UnknownBlock from '../../_block_components/unknown_block';

const Contacts = ({ publication, globalIndex }) => {
  const pageType = useSelector((state) => state.currentTab.type);
  const [publicationData, setPublicationData] = React.useState(null);
  const [contentData, setContentData] = React.useState(null);
  const [path_to_folder, setPath_to_folder] = React.useState(null);

  React.useEffect(() => {
    if (publication) {
      setPublicationData(publication);
    }
  }, [publication]);

  React.useEffect(() => {
    if (publicationData) {
      if (publicationData.content) {
        try {
          const parsedContent = JSON.parse(publicationData.content);
          setContentData(parsedContent);
        } catch (error) {
          setContentData(null);
        }
      }

      const folderName =
        pageType === 'tab_blank'
          ? (publicationData.blank_name || publicationData.eng_name)
          : publicationData.eng_name;
      if (publicationData.path && folderName) {
        const pathValue = `https://${publicationData.path}${folderName}/`;
        setPath_to_folder(pathValue);
      }
    }
  }, [publicationData, pageType]);

  const title = React.useMemo(() => {
    if (!contentData || !Array.isArray(contentData)) return null;

    const headerBlock = contentData.find((block) => (block.boock_tag === 'header_block' || block.block_tag === 'header_block'));
    if (!headerBlock || !headerBlock.block_content || !Array.isArray(headerBlock.block_content)) {
      return null;
    }

    const textContent = headerBlock.block_content.find(
      (content) => (content.cotent_type === 'text' || content.content_type === 'text') || (content.cotent_type === 'long_text' || content.content_type === 'long_text'),
    );

    return textContent?.content_text || null;
  }, [contentData]);

  const filteredBlocks = React.useMemo(() => {
    if (!contentData || !Array.isArray(contentData)) {
      return [];
    }

    return contentData.filter((blockData) => {
      if (blockData && (blockData.boock_tag === 'header_block' || blockData.block_tag === 'header_block')) {
        return false;
      }

      if (!blockData || !(blockData.boock_tag || blockData.block_tag)) {
        return false;
      }

      if (blockData.boock_tag === 'block_images' || blockData.block_tag === 'block_images') {
        return true;
      }

      if (
        !blockData.block_content ||
        !Array.isArray(blockData.block_content) ||
        blockData.block_content.length === 0
      ) {
        return false;
      }

      return true;
    });
  }, [contentData]);

  const { blocksBeforeMap, mapBlock, blocksAfterMap } = React.useMemo(() => {
    const mapIndex = filteredBlocks.findIndex((block) => (block.boock_tag === 'map_block' || block.block_tag === 'map_block'));

    if (mapIndex !== -1) {
      return {
        blocksBeforeMap: filteredBlocks.slice(0, mapIndex),
        mapBlock: filteredBlocks[mapIndex],
        blocksAfterMap: filteredBlocks.slice(mapIndex + 1),
      };
    }

    return {
      blocksBeforeMap: filteredBlocks,
      mapBlock: null,
      blocksAfterMap: [],
    };
  }, [filteredBlocks]);

  const allImagePaths = React.useMemo(() => {
    if (!path_to_folder || !contentData || !Array.isArray(contentData)) return [];
    const paths = [];
    const cleanName = (name) => {
      if (!name || name === 'none') return null;
      let n = name.includes('\\') ? name.substring(name.lastIndexOf('\\') + 1) : name;
      n = n.includes('/') ? n.substring(n.lastIndexOf('/') + 1) : n;
      return n;
    };
    contentData.forEach((block) => {
      if (!block?.block_content || !Array.isArray(block.block_content)) return;
      block.block_content.forEach((c) => {
        if (c.img_name && c.img_name !== 'none') {
          const name = cleanName(c.img_name);
          if (name) paths.push(path_to_folder + name);
        }
        if (c.imgs_names && c.imgs_names !== 'none' && c.imgs_names !== '[]') {
          let arr = [];
          try {
            arr = typeof c.imgs_names === 'string' ? JSON.parse(c.imgs_names) : c.imgs_names;
          } catch {
            arr = typeof c.imgs_names === 'string' ? c.imgs_names.split(',').map((s) => s.trim()) : [];
          }
          if (Array.isArray(arr)) {
            arr.forEach((imgName) => {
              const name = cleanName(imgName);
              if (name) paths.push(path_to_folder + name);
            });
          }
        }
      });
    });
    return paths;
  }, [contentData, path_to_folder]);

  // React.useEffect(() => {
  //   console.log('Contacts render:', {
  //     publication,
  //     globalIndex,
  //     publicationData,
  //     contentData,
  //     path_to_folder,
  //     title,
  //     filteredBlocks: filteredBlocks?.length ?? 0,
  //     blocksBeforeMap: blocksBeforeMap?.length ?? 0,
  //     mapBlock: !!mapBlock,
  //     blocksAfterMap: blocksAfterMap?.length ?? 0,
  //   });
  //   console.log('Contacts publicationData:', publicationData);
  //   if (allImagePaths.length > 0) {
  //     console.log('Contacts: полные имена картинок с путями:', allImagePaths);
  //   }
  // });

  const renderImgsBlockAsContacts = (blockData, key) => {
    if (!path_to_folder || !blockData?.block_content || !Array.isArray(blockData.block_content)) {
      return null;
    }
    const imgsBlock = blockData.block_content.find(
      (c) => c && (c.cotent_type === 'imgs_block' || c.content_type === 'imgs_block') && (c.imgs_names || c.imgs_names === '[]') && c.imgs_names !== 'none',
    );
    if (!imgsBlock?.imgs_names) return null;

    let namesArr = [];
    try {
      namesArr = typeof imgsBlock.imgs_names === 'string'
        ? JSON.parse(imgsBlock.imgs_names)
        : imgsBlock.imgs_names;
    } catch {
      namesArr = typeof imgsBlock.imgs_names === 'string'
        ? imgsBlock.imgs_names.split(',').map((s) => s.trim()).filter(Boolean)
        : [];
    }
    if (!Array.isArray(namesArr)) namesArr = [];

    const imgNames = namesArr
      .filter((name) => name && name !== 'none')
      .map((name) => (name && name.includes('\\') ? name.substring(name.lastIndexOf('\\') + 1) : name))
      .map((name) => (name && name.includes('/') ? name.substring(name.lastIndexOf('/') + 1) : name));

    let signaturesArr = [];
    if (imgsBlock.imgs_signatures && imgsBlock.imgs_signatures !== 'none' && imgsBlock.imgs_signatures !== '[]') {
      const raw = imgsBlock.imgs_signatures;
      try {
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        signaturesArr = Array.isArray(parsed) ? parsed : [];
      } catch {
        if (typeof raw === 'string') {
          signaturesArr = raw.split(',').map((s) => s.trim()).filter(Boolean);
        }
      }
    }
    const fallbackCaption = imgsBlock.content_text && String(imgsBlock.content_text).trim() !== '' && String(imgsBlock.content_text).toLowerCase() !== 'none'
      ? String(imgsBlock.content_text).trim()
      : null;
    const blockHeadingRaw = imgsBlock.content_text && String(imgsBlock.content_text).trim() !== '' && String(imgsBlock.content_text).toLowerCase() !== 'none'
      ? String(imgsBlock.content_text).trim()
      : null;

    const headingParts = blockHeadingRaw && blockHeadingRaw.includes(';')
      ? blockHeadingRaw.split(';').map((s) => s.trim()).filter(Boolean)
      : [];
    const blockHeadingTitle = headingParts.length > 0 ? headingParts[0] : blockHeadingRaw;
    const secondLineAsLink = headingParts.length >= 2 && String(headingParts[1]).toLowerCase() === 'links';

    return (
      <div key={key} className={styles.contactsTilesBlock}>
        {blockHeadingTitle && (
          <div className={styles.contactsTilesHeadingWrap}>
            <h2 className={styles.contactsTilesHeading}>{blockHeadingTitle}</h2>
          </div>
        )}
        <div className={styles.contactsTilesGrid}>
        {imgNames.map((imgName, idx) => {
          const signatureRaw = signaturesArr[idx];
          const signature = signatureRaw != null && String(signatureRaw).trim() !== '' && String(signatureRaw).trim().toLowerCase() !== 'none'
            ? String(signatureRaw).trim()
            : (signaturesArr.length === 0 ? fallbackCaption : null);
          const lines = signature
            ? signature.split(';').map((s) => s.trim()).filter(Boolean)
            : [];
          const tileLinkUrl =
            secondLineAsLink && lines[1]
              ? lines[1].startsWith('http://') || lines[1].startsWith('https://')
                ? lines[1]
                : `https://${lines[1].replace(/^\/+/, '')}`
              : null;
          const handleTileClick = () => {
            if (tileLinkUrl) window.open(tileLinkUrl, '_blank', 'noopener,noreferrer');
          };
          return (
            <div
              key={idx}
              className={tileLinkUrl ? `${styles.contactsTile} ${styles.contactsTileClickable}` : styles.contactsTile}
              onClick={handleTileClick}
              role={tileLinkUrl ? 'button' : undefined}
              tabIndex={tileLinkUrl ? 0 : undefined}
              onKeyDown={(e) => {
                if (tileLinkUrl && (e.key === 'Enter' || e.key === ' ')) {
                  e.preventDefault();
                  handleTileClick();
                }
              }}>
              <div className={styles.contactsTileIcon}>
                <img
                  src={path_to_folder + imgName}
                  alt={signature || `Контакт ${idx + 1}`}
                  className={styles.contactsTileIconImg}
                />
              </div>
              <div className={styles.contactsTileText}>
                {lines.length > 0 ? (
                  lines.map((line, i) => {
                    if (i === 1 && tileLinkUrl) return null;
                    const lineClass =
                      i === 0
                        ? styles.contactsTileLine1
                        : i === 1
                          ? styles.contactsTileLine2
                          : styles.contactsTileLine3;
                    return (
                      <span key={i} className={lineClass}>
                        {line}
                      </span>
                    );
                  })
                ) : (
                  '\u00A0'
                )}
              </div>
            </div>
          );
        })}
        </div>
      </div>
    );
  };

  const renderBlockImages = (blockData, key) => {
    if (!path_to_folder || !blockData?.block_content || !Array.isArray(blockData.block_content)) {
      return null;
    }
    const contentWithImgs = blockData.block_content.find(
      (c) => c && (c.imgs_names || c.imgs_names === '[]') && c.imgs_names !== 'none',
    );
    if (!contentWithImgs?.imgs_names) return null;

    let namesArr = [];
    try {
      namesArr = typeof contentWithImgs.imgs_names === 'string'
        ? JSON.parse(contentWithImgs.imgs_names)
        : contentWithImgs.imgs_names;
    } catch {
      namesArr = typeof contentWithImgs.imgs_names === 'string'
        ? contentWithImgs.imgs_names.split(',').map((s) => s.trim()).filter(Boolean)
        : [];
    }
    if (!Array.isArray(namesArr)) namesArr = [];

    const imgNames = namesArr
      .filter((name) => name && name !== 'none')
      .map((name) => (name && name.includes('\\') ? name.substring(name.lastIndexOf('\\') + 1) : name))
      .map((name) => (name && name.includes('/') ? name.substring(name.lastIndexOf('/') + 1) : name));

    let signaturesArr = [];
    if (contentWithImgs.imgs_signatures && contentWithImgs.imgs_signatures !== 'none' && contentWithImgs.imgs_signatures !== '[]') {
      const raw = contentWithImgs.imgs_signatures;
      try {
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        signaturesArr = Array.isArray(parsed) ? parsed : [];
      } catch {
        if (typeof raw === 'string') {
          signaturesArr = raw.split(',').map((s) => s.trim()).filter(Boolean);
        }
      }
    }
    const fallbackCaption = contentWithImgs.content_text && String(contentWithImgs.content_text).trim() !== '' && String(contentWithImgs.content_text).toLowerCase() !== 'none'
      ? String(contentWithImgs.content_text).trim()
      : null;

    return (
      <div key={key} className={styles.blockImagesBlock}>
        {imgNames.map((imgName, idx) => {
          const signatureRaw = signaturesArr[idx];
          const signature = signatureRaw != null && String(signatureRaw).trim() !== '' && String(signatureRaw).trim().toLowerCase() !== 'none'
            ? String(signatureRaw).trim()
            : (signaturesArr.length === 0 ? fallbackCaption : null);
          return (
            <div key={idx} className={styles.blockImagesItem}>
              <div className={styles.blockImagesImgWrap}>
                <img
                  src={path_to_folder + imgName}
                  alt={signature || `Изображение ${idx + 1}`}
                  className={styles.blockImagesImg}
                />
              </div>
              <div className={styles.blockImagesSignature}>
                {signature
                  ? signature
                      .split(';')
                      .map((s) => s.trim())
                      .filter(Boolean)
                      .map((line, i) => (
                        <div key={i} className={styles.signatureLine}>
                          {line}
                        </div>
                      ))
                  : '\u00A0'}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderBlock = (blockData, index) => {
    if (!blockData || !(blockData.boock_tag || blockData.block_tag)) {
      return <UnknownBlock key={index} blockData={blockData} path_to_folder={path_to_folder} />;
    }

    switch (blockData.boock_tag || blockData.block_tag) {
      case 'block_a':
        return (
          <BlockA
            key={index}
            blockData={blockData}
            path_to_folder={path_to_folder}
            blockIndex={index}
          />
        );
      case 'block_b':
        return (
          <BlockB
            key={index}
            blockData={blockData}
            path_to_folder={path_to_folder}
            blockIndex={index}
          />
        );
      case 'contacts_block':
        return renderImgsBlockAsContacts(blockData, index) ?? (
          <ContactsBlock
            key={index}
            blockData={blockData}
            path_to_folder={path_to_folder}
            blockIndex={index}
          />
        );
      case 'map_block':
        return (
          <MapBlock
            key={index}
            blockData={blockData}
            path_to_folder={path_to_folder}
            blockIndex={index}
          />
        );
      case 'adress_block':
        return (
          <ContactsAdressBlock
            key={index}
            blockData={blockData}
            path_to_folder={path_to_folder}
            blockIndex={index}
          />
        );
      case 'block_images':
        return renderBlockImages(blockData, index);
      default:
        return (
          <UnknownBlock
            key={index}
            blockData={blockData}
            path_to_folder={path_to_folder}
            blockIndex={index}
          />
        );
    }
  };

  return (
    <div className={styles.contacts}>
      <div className={styles.container}>
        {title && (
          <div className={styles.header}>
            <h1 className={styles.title}>{title}</h1>
          </div>
        )}

        {filteredBlocks.length > 0 ? (
          <div className={styles.blocksContainer}>
            {blocksBeforeMap.length > 0 && (
              <div className={styles.groupContainer}>
                {blocksBeforeMap.map((block, index) => (
                  <div key={index} className={styles.blockWrapper}>
                    {renderBlock(block, index)}
                  </div>
                ))}
              </div>
            )}

            {mapBlock && (
              <div key={`map-${filteredBlocks.indexOf(mapBlock)}`} className={styles.blockWrapper}>
                {renderBlock(mapBlock, filteredBlocks.indexOf(mapBlock))}
              </div>
            )}

            {blocksAfterMap.length > 0 && (
              <div className={styles.groupContainer}>
                {blocksAfterMap.map((block, index) => (
                  <div key={filteredBlocks.indexOf(block)} className={styles.blockWrapper}>
                    {renderBlock(block, filteredBlocks.indexOf(block))}
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div className={styles.noContent}>
            <p>Контактная информация не найдена</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Contacts;
